/**
 * Shopify Cart Utilities
 * Helper functions for cart operations
 */

class CartUtils {
  /**
   * Add item to cart
   */
  static async addItem(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      });

      if (response.ok) {
        const data = await response.json();
        await this.updateCartCount();
        return { success: true, data };
      } else {
        const error = await response.json();
        return { success: false, error };
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      return { success: false, error };
    }
  }

  /**
   * Add multiple items to cart
   */
  static async addItems(items) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });

      if (response.ok) {
        const data = await response.json();
        await this.updateCartCount();
        return { success: true, data };
      } else {
        const error = await response.json();
        return { success: false, error };
      }
    } catch (error) {
      console.error('Add items to cart error:', error);
      return { success: false, error };
    }
  }

  /**
   * Get current cart
   */
  static async getCart() {
    try {
      const response = await fetch('/cart.js');
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Get cart error:', error);
      return null;
    }
  }

  /**
   * Update cart count in UI
   */
  static async updateCartCount() {
    try {
      const cart = await this.getCart();
      if (cart) {
        // Update cart count elements
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count || 0;
        });

        // Trigger custom event
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }
    } catch (error) {
      console.error('Update cart count error:', error);
    }
  }

  /**
   * Update item quantity
   */
  static async updateItem(variantId, quantity) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: {
            [variantId]: quantity
          }
        })
      });

      if (response.ok) {
        const data = await response.json();
        await this.updateCartCount();
        return { success: true, data };
      } else {
        const error = await response.json();
        return { success: false, error };
      }
    } catch (error) {
      console.error('Update cart item error:', error);
      return { success: false, error };
    }
  }

  /**
   * Remove item from cart
   */
  static async removeItem(variantId) {
    return this.updateItem(variantId, 0);
  }
}

// Export for use in other scripts
if (typeof window !== 'undefined') {
  window.CartUtils = CartUtils;
}

